// @ts-nocheck
import {KTSVG} from '../../../../../../_metronic/helpers'
import {BASE_URL, useGetUserReportFileQuery} from '../../../../../../api'
import {useListView} from '../../core/ListViewProvider'
import {UsersListFilter} from './UsersListFilter'
import React, {useEffect, useState, useCallback} from 'react'
import {URL} from '../../../../../../api'
import * as XLSX from 'xlsx'
import moment from 'moment'
import axios from 'axios'
import {useSelector} from 'react-redux'

// First and last name as separate columns (for Mailchimp imports). If only
// one name field was filled in with a full name ("Maria Lopez"), split it at
// the first space. Missing names stay blank rather than "N/A".
const splitName = (u) => {
  let first = String(u?.firstName || '').trim()
  let last = String(u?.lastName || '').trim()
  if (!last && first.includes(' ')) {
    const i = first.indexOf(' ')
    last = first.slice(i + 1).trim()
    first = first.slice(0, i)
  } else if (!first && last.includes(' ')) {
    const i = last.indexOf(' ')
    first = last.slice(0, i)
    last = last.slice(i + 1).trim()
  }
  return {first, last}
}

const downloadExcel = (data) => {
  if (!data || data.length === 0) {
    alert('No data available to export')
    return
  }

  console.log('Exporting filtered users data:', {
    totalRecords: data.length,
    data: data,
  })

  // Transform data to match the exact table columns shown in the image
  const transformedData = data.map((user) => {
    // FIRST NAME / LAST NAME in separate columns
    const {first, last} = splitName(user)

    // PHONE: phone number
    const phone = user.phone || user.phoneNumber || 'N/A'

    // EMAIL: email address
    const email = user.email || 'N/A'

    // AVAILABLE ROLES: combine all roles into a single string
    let available_roles = 'N/A'
    if (user.roles && Array.isArray(user.roles) && user.roles.length > 0) {
      available_roles = user.roles.join(', ')
    } else if (user.role) {
      available_roles = user.role
    } else if (user.userType) {
      available_roles = user.userType
    }

    // STATUS: user status (Active/Inactive) - matches the isBlocked field used
    // by the live Users list table (user.status/isActive don't exist on the
    // schema, which previously made every exported row say "Inactive")
    const status = !user.isBlocked ? 'Active' : 'Inactive'

    // LOCATION: user location
    const location = user.location || user.primaryLocation || 'N/A'

    // Created Date: when user was created
    const created_date = user.createdAt ? moment(new Date(user.createdAt)).format('lll') : 'N/A'

    return {
      'FIRST NAME': first,
      'LAST NAME': last,
      PHONE: phone,
      EMAIL: email,
      'AVAILABLE ROLES': available_roles,
      STATUS: status,
      LOCATION: location,
      'CREATED DATE': created_date,
    }
  })

  console.log('Transformed users data for export:', transformedData)

  const worksheet = XLSX.utils.json_to_sheet(transformedData)
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Users')

  // Add filename with filter info and timestamp
  const fileName = `UsersData_${moment().format('YYYY-MM-DD_HH-mm')}.xlsx`
  XLSX.writeFile(workbook, fileName)

  // Show success message with record count
  alert(`Successfully exported ${data.length} filtered user records to ${fileName}`)
}

const UsersListToolbar = ({
  page,
  setPage,
  sDate,
  setSDate,
  setEDate,
  eDate,
  genderFilter,
  setGenderFilter,
  typeFilter,
  setTypeFilter,
  locationFilter,
  setLocationFilter,
  applyFilter,
  setApplyFilter,
  loading,
  setLoading,
  usersData,
}) => {
  const {setItemIdForUpdate} = useListView()
  const [exportLoading, setExportLoading] = useState(false)

  // Get current filter state from Redux
  const userFilter = useSelector((state) => state.filter.usersFilter)

  const openAddUserModal = useCallback(() => {
    setItemIdForUpdate(null)
  }, [setItemIdForUpdate])

  const handleExport = useCallback(async () => {
    if (loading) {
      alert('Please wait for data to load before exporting')
      return
    }

    try {
      setExportLoading(true)
      console.log('Starting export of all filtered data...')

      // Make API call to get ALL filtered data (not just current page)
      const response = await axios.get(`${BASE_URL}/admin/users`, {
        params: {
          page: 1, // Start from page 1
          limit: 10000, // Set a very high limit to get all data
          search: userFilter.search || '',
          startDate: userFilter.startDate || sDate || '',
          endDate: userFilter.endDate || eDate || '',
          location: userFilter.location || locationFilter || '',
          type: userFilter.type || typeFilter || '',
          gender: genderFilter || '',
          // Remove pagination to get all results
          export: true, // Add flag to indicate this is for export
        },
      })

      const {docs} = response.data
      console.log('Export API response - Total filtered records:', docs.length)

      if (!docs || docs.length === 0) {
        alert('No data found matching the current filters')
        return
      }

      // Export all filtered data
      downloadExcel(docs)
    } catch (error) {
      console.error('Error during export:', error)
      alert('Error occurred while exporting data. Please try again.')
    } finally {
      setExportLoading(false)
    }
  }, [loading, userFilter, sDate, eDate, locationFilter, typeFilter, genderFilter])

  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      <UsersListFilter
        genderFilter={genderFilter}
        setGenderFilter={setGenderFilter}
        sDate={sDate}
        setSDate={setSDate}
        setEDate={setEDate}
        eDate={eDate}
        page={page}
        setPage={setPage}
        typeFilter={typeFilter}
        setTypeFilter={setTypeFilter}
        locationFilter={locationFilter}
        setLocationFilter={setLocationFilter}
        applyFilter={applyFilter}
        setApplyFilter={setApplyFilter}
      />

      {/* begin::Export Options */}
      <div className='d-flex flex-column me-3'>
        {/* Filter Info Message */}
        {/* {usersData && usersData.length > 0 && (
          <div className='text-muted fs-7 mb-2 text-center'>
            📊 Current page: {usersData.length} users
            {sDate && eDate && (
              <span className='ms-2'>
                • Date: {moment(sDate).format('MMM DD')} - {moment(eDate).format('MMM DD, YYYY')}
              </span>
            )}
            {typeFilter && <span className='ms-2'>• Type: {typeFilter}</span>}
            {locationFilter && <span className='ms-2'>• Location: {locationFilter}</span>}
            {genderFilter && <span className='ms-2'>• Gender: {genderFilter}</span>}
            <div className='text-info mt-1'>
              ⚠️ Export will include ALL filtered data across all pages
            </div>
          </div>
        )} */}

        {/* Export Button */}
        <button
          type='button'
          className='btn btn-light-primary'
          onClick={handleExport}
          disabled={loading || exportLoading}
          title='Export ALL filtered user records to Excel (across all pages)'
        >
          <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
          <span>{exportLoading ? 'Exporting...' : 'Export All'}</span>
        </button>
      </div>
      {/* end::Export Options */}

      {/* begin::Add user */}
      {/* <button type='button' className='btn btn-primary' onClick={openAddUserModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        Add User
      </button> */}
      {/* end::Add user */}
    </div>
  )
}

export {UsersListToolbar}
